// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1F54A","alertIcon":"ConfirmModal_alertIcon__23Obk"};